// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-70cb5c39] .formulate-input-label {
    margin: 0;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
    font-family: Roboto;
    line-height: 1.5;
    font-size: 1rem;
    font-weight: 400;
}
[data-v-70cb5c39] .formulate-input-label:hover {
    cursor: pointer;
}
[data-v-70cb5c39] .formulate-input-wrapper {
    display: flex;
    align-items: flex-start;
}
[data-v-70cb5c39] .formulate-input-link {
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
    text-decoration-line: underline;
    outline: 2px solid transparent;
    outline-offset: 2px;
}
[data-v-70cb5c39] .formulate-input-help {
    margin-top: -0.25rem;
    margin-bottom: 1rem;
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
    font-family: Roboto;
    line-height: 1.5;
    font-size: 0.875rem;
    font-weight: 400;
}
[data-v-70cb5c39] .formulate-input-errors {
    margin: 0;
    margin-top: 0.5rem;
    list-style-type: none;
    padding: 0;
    --tw-text-opacity: 1;
    color: rgb(216 0 3 / var(--tw-text-opacity));
    font-family: Roboto;
    line-height: 1.5;
    font-size: 0.875rem;
    font-weight: 400;
}
[data-v-70cb5c39] .formulate-input-element {
    margin-top: 0.25rem;
    display: flex;
}
.formulate-input[data-v-70cb5c39] {
    position: relative;
    margin-bottom: 2rem;
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity));
}
.formulate-input[data-v-70cb5c39][data-is-showing-errors='true'] input {
    border-top-width: 1px;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(216 0 3 / var(--tw-border-opacity));
}
.formulate-input[data-v-70cb5c39] input {
    margin: 0;
    height: 1.25rem;
    width: 1.25rem;
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
    border-radius: 5px;
    border-width: 1px;
    border-style: solid;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
    background-position: center;
    background-repeat: no-repeat;
    padding: 0;
}
.formulate-input[data-v-70cb5c39] input:checked {
    --tw-border-opacity: 1;
    border-color: rgb(31 47 75 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(31 47 75 / var(--tw-bg-opacity));
}
.formulate-input[data-v-70cb5c39] input {
    background-image: url('/img/web/checkbox-check.svg');
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/inputs/box/LinkableCheckboxInput.vue"],"names":[],"mappings":";AAgDA;IAAA,SAAA;IAAA,oBAAA;IAAA,qBAAA;IAAA,oBAAA;IAAA,6CAAA;IAAA,mBAAA;IAAA,gBAAA;IAAA,eAAA;IAAA,gBAAA;AAAA;AAAA;IAAA,eAAA;AAAA;AAIA;IAAA,aAAA;IAAA,uBAAA;AAAA;AAIA;IAAA,oBAAA;IAAA,6CAAA;IAAA,+BAAA;IAAA,8BAAA;IAAA,mBAAA;AAAA;AAIA;IAAA,oBAAA;IAAA,mBAAA;IAAA,oBAAA;IAAA,gDAAA;IAAA,mBAAA;IAAA,gBAAA;IAAA,mBAAA;IAAA,gBAAA;AAAA;AAIA;IAAA,SAAA;IAAA,kBAAA;IAAA,qBAAA;IAAA,UAAA;IAAA,oBAAA;IAAA,4CAAA;IAAA,mBAAA;IAAA,gBAAA;IAAA,mBAAA;IAAA,gBAAA;AAAA;AAIA;IAAA,mBAAA;IAAA,aAAA;AAAA;AAIA;IAAA,kBAAA;IAAA,mBAAA;IAAA,oBAAA;IAAA,6CAAA;AAAA;AAIA;IAAA,qBAAA;IAAA,wBAAA;IAAA,sBAAA;IAAA,qDAAA;AAAA;AAKA;IAAA,SAAA;IAAA,eAAA;IAAA,cAAA;IAAA,wBAAA;OAAA,qBAAA;YAAA,gBAAA;IAAA,kBAAA;IAAA,iBAAA;IAAA,mBAAA;IAAA,sBAAA;IAAA,yDAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,UAAA;AAAA;AAAA;IAAA,sBAAA;IAAA,sDAAA;IAAA,kBAAA;IAAA,sDAAA;AAAA;AADA;IAEA,oDAAA;AACA","sourcesContent":["<template>\n  <FormulateInput type=\"checkbox\" v-bind=\"$attrs\" v-model=\"model\">\n    <template #label>\n      <label class=\"formulate-input-label\" :class=\"`formulate-input-label--${labelPosition}`\" @click=\"model = !model\">\n        <template v-for=\"(link, index) in label\">\n          {{ link.label }} <a v-if=\"link\" :key=\"index\" :href=\"link.link\" target=\"_blank\" class=\"formulate-input-link\">{{ link.text }}</a>\n        </template>\n        <span v-if=\"trailingLabel\">{{ trailingLabel }}</span>\n        <span v-if=\"isRequired\">*</span>\n      </label>\n    </template>\n  </FormulateInput>\n</template>\n\n<script>\nimport { ref } from '@vue/composition-api';\n\nexport default {\n  props: {\n    label: {\n      type: Array,\n      default: () => [],\n    },\n    trailingLabel: {\n      type: String,\n      default: null,\n    },\n    labelPosition: {\n      type: String,\n      default: 'after',\n    },\n    checked: {\n      type: Boolean,\n      default: false,\n    },\n  },\n  setup(props, context) {\n    return {\n      model: ref(props.checked),\n      isRequired: (context.attrs.validation ?? '').includes('accepted'),\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n/deep/ .formulate-input {\n  &-label {\n    @apply style-body-sm m-0 text-neutral-ultradark px-nano hover:cursor-pointer;\n  }\n\n  &-wrapper {\n    @apply flex items-start;\n  }\n\n  &-link {\n    @apply underline outline-none text-neutral-ultradark;\n  }\n\n  &-help {\n    @apply style-overline text-neutral-medium -mt-quark mb-xxxs;\n  }\n\n  &-errors {\n    @apply style-overline text-feedback-error-medium mt-nano m-0 p-0 list-none;\n  }\n\n  &-element {\n    @apply flex mt-quark;\n  }\n}\n.formulate-input::v-deep {\n  @apply relative text-neutral-ultradark mb-xs;\n\n  &[data-is-showing-errors='true'] {\n    input {\n      @apply border-feedback-error-medium border-y-hairline;\n    }\n  }\n\n  input {\n    @apply w-[1.25rem] h-[1.25rem] border-solid p-0 rounded-[5px] border-hairline border-neutral-semilight appearance-none bg-no-repeat bg-center checked:bg-brand-secondary-medium checked:border-brand-secondary-medium m-0;\n    background-image: url('/img/web/checkbox-check.svg');\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
